/**
 * LES PROFILS ATTRIBUABLES À UN COMPTE — une seule liste, pour deux écrans.
 *
 * ── Pourquoi elle est ici et pas dans un écran (30/08/2026) ────────────────
 *
 * « Droits par section » n'en connaissait que trois — technicien, responsable,
 * super admin — parce qu'il ne règle que les rubriques internes. L'annuaire des
 * comptes, lui, en attribue cinq : un confrère est `partner`, un compte réduit
 * à la vitrine est `public`. Les deux écrans vivant désormais dans le même
 * paramétrage, deux listes divergentes s'y verraient tout de suite — et l'une
 * des deux serait fausse.
 *
 * ⚠️ CES CLÉS SONT CELLES DU MOTEUR (`up_users.profile`). Les renommer ne
 * renomme rien : elles sont écrites en base, lues par le contrôleur `team` et
 * par la garde de section. Le libellé, lui, est libre.
 */
export type ProfilOption = { value: string; label: string; aide: string };
import { LIBELLES_PROFILS } from '@/shared/profilsLibelles';

/* Libellés et aides : `shared/ui/profilsLibelles.ts` (05/10/2026 — Base, Admin,
   Super admin), la même source que le site et le catalogue. */
const L = LIBELLES_PROFILS;
export const PROFILS_COMPTES: ProfilOption[] = [
  { value: 'technician', label: L.technician.label, aide: L.technician.aide },
  { value: 'manager', label: L.manager.label, aide: L.manager.aide },
  { value: 'superadmin', label: L.superadmin.label, aide: L.superadmin.aide },
  /* ⚠️ `partner` N'OUVRE PAS LA QUALITÉ. C'est le compte d'un confrère
     prescripteur : site et catalogue, rien d'autre. Le contrôleur `team` le
     tient (`{ site: true, manuel: true, ged: false }`) — l'écran ne fait que le
     dire, il ne le décide pas. */
  { value: 'partner', label: L.partner.label, aide: L.partner.aide },
  { value: 'public', label: L.public.label, aide: L.public.aide },
];

export const libelleProfil = (v: string) =>
  PROFILS_COMPTES.find((p) => p.value === v)?.label || v;
